module.exports = "'data:image/svg+xml;utf8,<svg width=\"12\" height=\"7\" viewBox=\"0 0 12 7\" xmlns=\"http://www.w3.org/2000/svg\"><title>Arrow Up Copy 2</title><path d=\"M5.998 4.294l4.05-3.966c.44-.43 1.168-.436 1.615.002a1.1 1.1 0 0 1 .002 1.584l-4.86 4.76A1.15 1.15 0 0 1 6 7a1.135 1.135 0 0 1-.808-.325l-4.86-4.76A1.108 1.108 0 0 1 .333.33c.45-.44 1.17-.44 1.616-.002l4.048 3.966z\" fill=\"%2349B7FF\" fill-rule=\"evenodd\"/></svg>'"


/*****************
 ** WEBPACK FOOTER
 ** ./src/Toggle/arrowExpanded.svg
 ** module id = 143
 ** module chunks = 0
 **/